import React from 'react';
import staticData from './staticData.json';
import { DataNode } from '../utils/PickUpTypes';

const AutostadtContext = React.createContext<DataNode[]>([]);

type Props = {
    children: React.ReactNode;
};

export function AutostadtContextProvider({ children }: Props) {
    const [config, setConfig] = React.useState(staticData);

    React.useEffect(() => {
        fetch('https://www.autostadt.de/delegate/events')
                .then(res => res.text())
                .then(text => {
                    const cleaned = text
                            .replace(/\t/g, ' ')
                            .replace(/[\x00-\x08\x0B\x0C\x0E-\x1F]/g, ' ');

                    return JSON.parse(cleaned);
                })
                .then(apiData => {
                    setConfig(prev => {
                        const existingTitles = new Set(
                                prev.map(item => item.titel)
                        );

                        const filteredApiData = apiData.filter(
                                (item: DataNode) => !existingTitles.has(item.titel)
                        );

                        return [...prev, ...filteredApiData];
                    });
                });
    }, []);

    return <AutostadtContext.Provider value={config}>{children}</AutostadtContext.Provider>;
}

export const useConfig = () => React.useContext(AutostadtContext);
